import {
  alpha,
  TextField,
  TextFieldProps as MuiTextFieldProps,
  styled,
} from "@mui/material";

export type CustomTextFieldProps = {
  mask?: string;
} & MuiTextFieldProps;

const StyledTextField = styled(TextField)<CustomTextFieldProps>(
  ({ theme }) => ({
    "& .MuiOutlinedInput-input": {
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 14,
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.background.default, 0.28)
          : theme.palette.background.paper,
      transition: "background-color 0.2s ease, border-color 0.2s ease",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: 2,
      borderColor: theme.palette.divider,
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.divider,
    },
  })
);

const LightTextField = (props: CustomTextFieldProps) => {
  return <StyledTextField {...props} />;
};

export default LightTextField;
